module.exports = __webpack_public_path__ + "img/lixiuzhen.abe630a6.png";